import DeliveryCsvNotasEmAtrasoSchema from '@/schema/DeliveryCsvNotasEmAtraso.schema'
import Carga from '@/model/resource/Carga'

export default class DeliveryCsvNotasEmAtraso extends Carga {

  get $schema() {
    return DeliveryCsvNotasEmAtrasoSchema(this)
  }
}
